import { render } from "./B2bTableMenuTaxes.vue?vue&type=template&id=a5d1b55c&scoped=true&lang=pug"
import script from "./B2bTableMenuTaxes.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuTaxes.vue?vue&type=script&lang=js"

import "./B2bTableMenuTaxes.vue?vue&type=style&index=0&id=a5d1b55c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d1b55c"]])

export default __exports__